import { defineComponent as _defineComponent } from 'vue'

/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'NumberedBreadcrumbItem',
  props: {
    active: { type: Boolean },
    disabled: { type: Boolean },
    index: null,
    slim: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})